import * as ContextMenuPrimitive from '@radix-ui/react-context-menu';

export const ContextMenu = ContextMenuPrimitive.Root;
